export default __webpack_public_path__ + "static/media/linkdin.f432cdf7.svg";